import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography, styled } from '@mui/material';
import React from 'react';
var prefix = 'login-card';
var classes = {
    container: "".concat(prefix, "-container"),
    title: "".concat(prefix, "-title"),
    logo: "".concat(prefix, "-logo"),
};
var StyledDiv = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.container)] = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderStyle: 'none',
            borderRadius: 20,
            borderColor: 'black',
            padding: '70px',
            width: 'fit-content',
            minWidth: 250,
            backgroundColor: 'snow',
            boxShadow: theme.shadows[12],
        },
        _b["& .".concat(classes.title)] = {
            color: '#44497a',
        },
        _b["& .".concat(classes.logo)] = {
            width: 100,
            margin: '25px 0px 50px 0px',
        },
        _b);
});
export var LoginCard = React.forwardRef(function (_a, ref) {
    var title = _a.title, logo = _a.logo, onLoginClick = _a.onLoginClick, children = _a.children;
    return (_jsxs(StyledDiv, { ref: ref, className: classes.container, children: [_jsx(Typography, { variant: "h4", className: classes.title, children: title }), _jsx("img", { src: logo, alt: "", className: classes.logo }), _jsx(Button, { variant: "contained", "aria-label": "Login", onClick: onLoginClick, children: "Login" }), children] }));
});
export default LoginCard;
